"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaterialStylesContext = void 0;
exports.withMaterialStyles = withMaterialStyles;
exports.withMaterialTheme = withMaterialTheme;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _styles2 = require("@mui/material/styles");
var _StyledEngineProvider = _interopRequireDefault(require("@mui/material/StyledEngineProvider"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _excluded = ["theme"],
  _excluded2 = ["classes", "forwardedRef"];
var generateClassNameFunctions = {};
var MaterialStylesContext = /*#__PURE__*/(0, _react.createContext)({
  generateClassName: null,
  classNamePrefix: null
});
exports.MaterialStylesContext = MaterialStylesContext;
function withMaterialTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ComposedComponent = arguments.length > 1 ? arguments[1] : undefined;
  var WithMaterialTheme = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2["default"])(WithMaterialTheme, _PureComponent);
    var _super = (0, _createSuper2["default"])(WithMaterialTheme);
    function WithMaterialTheme(_props, context) {
      var _this;
      (0, _classCallCheck2["default"])(this, WithMaterialTheme);
      _this = _super.call(this, _props, context);
      _this.mediaQueryListener = function (e) {
        if (e.type === "change") {
          var media = e.media;
          var prevState = _this.state.mediaQuery;
          var mediaQuery = (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, prevState), {}, (0, _defineProperty2["default"])({}, media, e.matches));
          _this.theme = _this.getTheme({
            theme: options.theme,
            mediaQuery: mediaQuery
          });
          _this.setState(mediaQuery);
        }
      };
      _this.getTheme = function (_ref) {
        var theme = _ref.theme,
          props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
        return (0, _styles2.experimental_extendTheme)(typeof options.theme == "function" ? options.theme(props) : options.theme);
      };
      var wapp = _this.context.wapp;
      var _mediaQuery = _this.getMediaQueries(options.mediaQuery);
      _this.theme = _this.getTheme({
        theme: options.theme,
        mediaQuery: _mediaQuery
      });
      var classNamePrefix = options.classNamePrefix || wapp.globals.WAPP;
      _this.classNamePrefix = classNamePrefix;
      if (!generateClassNameFunctions[classNamePrefix] || wapp.target === "node") {
        var _generateClassName = (0, _styles.createGenerateClassName)({
          seed: classNamePrefix,
          productionPrefix: classNamePrefix
        });
        generateClassNameFunctions[classNamePrefix] = function () {
          return _generateClassName.apply(void 0, arguments);
        };
      }
      var generateClassName = generateClassNameFunctions[classNamePrefix];
      _this.generateClassName = generateClassName;
      _this.sheets = new _styles.ServerStyleSheets({
        serverGenerateClassName: generateClassName
      });
      if (wapp.target === "node") {
        _this.addStyle();
      }
      _this.state = {
        mediaQuery: _mediaQuery
      };
      return _this;
    }
    (0, _createClass2["default"])(WithMaterialTheme, [{
      key: "getMediaQueries",
      value: function getMediaQueries(queries) {
        var mediaQueryListener = this.mediaQueryListener;
        var mediaQuery = {};
        var shouldRemoveListenersForMedia = this.shouldRemoveListenersForMedia || {};
        queries.forEach(function (query) {
          var key = query;
          var mediaQueryList = typeof window !== "undefined" ? window.matchMedia(query) : false;
          if (mediaQueryList && typeof mediaQueryList.addEventListener !== "undefined") {
            if (shouldRemoveListenersForMedia[key]) {
              shouldRemoveListenersForMedia[key]();
              delete shouldRemoveListenersForMedia[key];
            }
            mediaQueryList.addEventListener("change", mediaQueryListener);
            shouldRemoveListenersForMedia[key] = function removeMediaListener() {
              mediaQueryList.removeEventListener("change", mediaQueryListener);
            };
          }
          mediaQuery[key] = mediaQueryList;
          if (mediaQuery[key] && typeof mediaQuery[key].matches !== "undefined") {
            mediaQuery[key] = mediaQuery[key].matches;
          }
        });
        this.shouldRemoveListenersForMedia = shouldRemoveListenersForMedia;
        return mediaQuery;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var shouldRemoveListenersForMedia = this.shouldRemoveListenersForMedia || {};
        Object.keys(shouldRemoveListenersForMedia).forEach(function (key) {
          shouldRemoveListenersForMedia[key]();
        });
      }
    }, {
      key: "createCssModule",
      value: function createCssModule() {
        var sheets = this.sheets;
        return {
          _module: {
            id: "./src/common/components/Template/materialStyle.css"
          },
          _getCss: function _getCss() {
            return sheets.toString();
          }
        };
      }
    }, {
      key: "addStyle",
      value: function addStyle() {
        var wapp = this.context.wapp;
        var module = this.createCssModule();
        wapp.styles.add(module);
      }
    }, {
      key: "render",
      value: function render() {
        var wapp = this.context.wapp;
        if (wapp.target === "node") {
          return this.sheets.collect( /*#__PURE__*/_react["default"].createElement(_styles2.Experimental_CssVarsProvider, {
            theme: this.theme
          }, /*#__PURE__*/_react["default"].createElement(MaterialStylesContext.Provider, {
            value: {
              generateClassName: this.generateClassName,
              classNamePrefix: this.classNamePrefix
            }
          }, /*#__PURE__*/_react["default"].createElement(_styles.StylesProvider, {
            generateClassName: this.generateClassName
          }, /*#__PURE__*/_react["default"].createElement(_StyledEngineProvider["default"], {
            generateClassName: this.generateClassName
          }, /*#__PURE__*/_react["default"].createElement(ComposedComponent, this.props))))));
        }
        return /*#__PURE__*/_react["default"].createElement(_styles2.Experimental_CssVarsProvider, {
          theme: this.theme
        }, /*#__PURE__*/_react["default"].createElement(MaterialStylesContext.Provider, {
          value: {
            generateClassName: this.generateClassName,
            classNamePrefix: this.classNamePrefix
          }
        }, /*#__PURE__*/_react["default"].createElement(_styles.StylesProvider, {
          generateClassName: this.generateClassName
        }, /*#__PURE__*/_react["default"].createElement(_StyledEngineProvider["default"], {
          generateClassName: this.generateClassName
        }, /*#__PURE__*/_react["default"].createElement(ComposedComponent, this.props)))));
      }
    }]);
    return WithMaterialTheme;
  }(_react.PureComponent);
  var displayName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  WithMaterialTheme.displayName = "WithMaterialTheme(".concat(displayName, ")");
  WithMaterialTheme.contextType = _Wapp.WappContext;
  WithMaterialTheme.ComposedComponent = ComposedComponent;
  return WithMaterialTheme;
}
function withMaterialStyles() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ComposedComponent = arguments.length > 1 ? arguments[1] : undefined;
  var WithMaterialStyles = /*#__PURE__*/function (_PureComponent2) {
    (0, _inherits2["default"])(WithMaterialStyles, _PureComponent2);
    var _super2 = (0, _createSuper2["default"])(WithMaterialStyles);
    function WithMaterialStyles() {
      (0, _classCallCheck2["default"])(this, WithMaterialStyles);
      return _super2.apply(this, arguments);
    }
    (0, _createClass2["default"])(WithMaterialStyles, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          classes = _this$props.classes,
          forwardedRef = _this$props.forwardedRef,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded2);
        return /*#__PURE__*/_react["default"].createElement(ComposedComponent, Object.assign({}, rest, {
          ref: forwardedRef,
          materialStyle: classes
        }));
      }
    }]);
    return WithMaterialStyles;
  }(_react.PureComponent);
  var displayName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  WithMaterialStyles.displayName = "WithMaterialStyles(".concat(displayName, ")");
  WithMaterialStyles.contextType = _Wapp.WappContext;
  WithMaterialStyles.ComposedComponent = ComposedComponent;
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var _useContext = (0, _react.useContext)(MaterialStylesContext),
      generateClassName = _useContext.generateClassName,
      _useContext$className = _useContext.classNamePrefix,
      classNamePrefix = _useContext$className === void 0 ? "default" : _useContext$className;
    WithMaterialStyles.StyledComponent = (0, _styles.withStyles)(styles, {
      generateClassName: generateClassName || generateClassNameFunctions[classNamePrefix]
    })(WithMaterialStyles);
    var StyledComponent = WithMaterialStyles.StyledComponent;
    return /*#__PURE__*/_react["default"].createElement(StyledComponent, Object.assign({}, props, {
      forwardedRef: ref
    }));
  });
}